import { render } from "./IndexFooter.vue?vue&type=template&id=41eb2d96&scoped=true"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"

import "./IndexFooter.vue?vue&type=style&index=0&id=41eb2d96&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41eb2d96"]])

export default __exports__